import { useState } from 'react';

interface SmartImageProps {
  /** Local path under the public folder, e.g. "images/products/rds-pain-balm-white.webp" */
  preferredSrc: string;
  /** Remote/online image used automatically if the local file is not found yet */
  fallbackSrc: string;
  alt: string;
  title?: string;
  className?: string;
}

/**
 * Renders a local product image first and silently falls back to the online
 * image until the real file is dropped into the public folder.
 */
export default function SmartImage({ preferredSrc, fallbackSrc, alt, title, className }: SmartImageProps) {
  const base = import.meta.env.BASE_URL || '/';
  const resolve = (path: string) => (path.startsWith('http') ? path : `${base}${path.replace(/^\//, '')}`);

  const [src, setSrc] = useState(resolve(preferredSrc));
  const [usedFallback, setUsedFallback] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      title={title}
      className={className}
      onError={() => {
        if (!usedFallback) {
          setUsedFallback(true);
          setSrc(resolve(fallbackSrc));
        }
      }}
    />
  );
}